import { Modal } from 'antd'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useStores } from '../../stores/RootStoreContext'

/** @type {import('react').FC<import('antd').ModalProps & { modalId: string }>} */
export const AppModal = observer((props) => {
  const { modalId, children, ...rest } = props

  const { modalStore } = useStores()

  useEffect(() => {
    if (!modalStore.modals.has(modalId)) {
      modalStore.addModal(modalId)
    }
  }, [modalId])

  const isOpen = modalStore.openModalsIds.includes(modalId)

  if (!children) return null

  return (
    <Modal open={isOpen} {...rest}>
      {children}
    </Modal>
  )
})
